import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebFamFamily } from '../models/family.model';
import { PersonService } from '../services/person.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class FamilyService {

    constructor(private httpClient: HttpClient, private personService: PersonService) { }

    getFamily(id: string) {
        return this.httpClient.get<WebFamFamily>(environment.backendUrl + '/family/get/tree/' + environment.currentTree + '/family/' + id);
    }

    lookupFamily(name: string) {
        return this.httpClient.get<WebFamFamily[]>(environment.backendUrl + '/family/lookup/tree/' + environment.currentTree
            + '/text/' + name);
    }

    insertFamily(data: WebFamFamily) {
        return this.httpClient.post<WebFamFamily>(environment.backendUrl + '/family/insert/tree/'
            + environment.currentTree, { data });
    }

    updateFamily(data: WebFamFamily) {
        return this.httpClient.patch<WebFamFamily>(
                    environment.backendUrl + '/family/update/tree/' + environment.currentTree + '/family/' + data.id,
                    { data }
                );
    }

    /**
     * Zapis samej kolejności związków.
     *
     * Wysyła WYŁĄCZNIE identyfikatory i pola kolejności. Backend traktuje samą
     * obecność pola `children` jako polecenie zsynchronizowania listy dzieci,
     * a `new WebFamFamily()` ma `children = []` z inicjalizacji pola klasy -
     * pełny obiekt kasował więc dzieci rodziny przy zwykłym przestawieniu
     * małżeństw. Pola pominięte znikają przy serializacji JSON, więc backend
     * ich nie zobaczy.
     */
    updateFamilyOrder(family: WebFamFamily) {
        const data = {
            id: family.id,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            tree_id: family.tree_id,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            husband_id: family.husband_id,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            wife_id: family.wife_id,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            husband_order: family.husband_order,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            wife_order: family.wife_order
        };
        return this.httpClient.patch<WebFamFamily>(
                    environment.backendUrl + '/family/update/tree/' + environment.currentTree + '/family/' + family.id,
                    { data }
                );
    }

    removeFamily(id: string) {
        return this.httpClient.delete<string>(environment.backendUrl + '/family/remove/tree/' + environment.currentTree + '/family/' + id);
    }

    formatLookupFamily(value?: string | WebFamFamily, full?: boolean): string {
        if (typeof value === 'string') {
            return value;
        }
        if ((value) && (value.id)) {
            let husband = this.personService.formatDisplayFullName(value.husband_person);
            let wife = this.personService.formatDisplayFullName(value.wife_person);
            husband = husband ? husband : 'N. N.';
            wife = wife ? wife : 'N. N.';
            return husband + ' & ' + wife;
        } else {
            return '';
        }
    }
}
